import React, { useEffect, useState } from "react";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";
import axios from "axios";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";
import Datatables from "component/master/menu/Datatables";
import ModalForm from "component/master/menu/ModalForm";

function Menu() {
  const [modalMode, setModalMode] = useState(null);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [menu, setMenu] = useState([]);

  const fetchMenu = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(`${process.env.REACT_APP_API}/menu`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });
  
      if (!response.ok) throw new Error("Gagal mengambil data menu");
  
      const data = await response.json();
      setMenu(data.data);
    } catch (error) {
      console.error("Error fetching menu:", error);
    }
  };

  useEffect(() => {
      document.title = "Green Hill Kemuning | Menu";
      window.scrollTo(0, 0);
      fetchMenu();
  }, []);


  const handleAddMenu = () => {
    setModalMode("add");
    setSelectedMenu(null);
    setIsModalOpen(true);
  }

  const handleEditMenu = (menu) => {
    setModalMode("edit");
    setSelectedMenu(menu);
    setIsModalOpen(true);
  }

  const handleDeleteMenu = async (menu) => {
    try {
      const confirmed = await showConfirm({
        title: 'Hapus Menu',
        text: `Apakah Anda yakin ingin menghapus menu ${menu.name}?`,
        confirmButtonText: 'Hapus'
      });
      if (!confirmed) return;
  
      const response = await axios.delete(
        `${process.env.REACT_APP_API}/menu/${menu.menuname}`
      );
  
      if (response.status === 200 || response.status === 201) {
        showSuccess(response.data.message || "Menu berhasil dihapus");
        fetchMenu();
      } else {
        showError(response.data.message || "Gagal menghapus menu");
      }
    } catch (error) {
      console.error("Error deleting menu:", error);
      showError(error.response?.data?.message || "Terjadi kesalahan saat menghapus menu");
    }
  };  
    

  const closeModal = () => {
    setIsModalOpen(false);
  }
      
  return (
    <div class="layout-wrapper layout-content-navbar">
      <div class="layout-container">
        <Sidebar />

        <div class="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
            <Navbar />
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                  <div class="row px-4">
                      <div class="card shadow p-3">
                        <div class="card-body">
                          <div class="row">
                            <div className="d-flex justify-content-between align-items-center">
                              <h5 className="card-title m-0">Menu Management</h5>
                              <i className="bx bxs-plus-square" 
                                style={{ color: "blue", fontSize: 50, cursor: "pointer" }} 
                                onClick={handleAddMenu}>
                              </i>
                            </div>
                            <Datatables data={menu} onEditMenu={handleEditMenu} onDeleteMenu={handleDeleteMenu}/>
                          </div>
                        </div>  
                      </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div class="layout-overlay layout-menu-toggle"></div>

      {isModalOpen && (
        <div className="modal fade show" style={{ display: "block" }}>
          <ModalForm mode={modalMode} menuData={selectedMenu} closeModal={closeModal} onSuccess={fetchMenu}/>
        </div>
      )}

    </div>
  );
}

export default Menu;
